<template>
  <div class="SystemRequirements">
    <span v-html="infoIconSvg" />
    <div class="tooltip">
      <svg width="16" height="10" class="tooltipTri">
        <polygon points="0,10 8,0 16,10" fill="#08192E" />
      </svg>
      <div class="heading">{{ systemRequirementsText }}</div>
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import strings from '../strings.json'

import infoIconSvg from '~/assets/ui/info-icon.svg?raw'

export default {
  inject: [ 'locale' ],
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    systemRequirementsText() {
      return strings[this.locale].systemRequirements
    },
  },
  data() {
    return {
      infoIconSvg,
    }
  },
}
</script>

<style scoped>

.SystemRequirements {
  display: inline-block;
  position: relative;
}

.SystemRequirements:hover .tooltip {
  visibility: visible;
}

.tooltip {
  visibility: hidden;
  padding: var(--spacing-3);
  border-radius: 4px;
  background-color: var(--bg-color-dark-blue);
  color: var(--text-color-white);
  position: absolute;
  left: -11px;
  top: 31px;
  width: max-content;
  z-index: 10;
}

.tooltipTri {
  position: absolute;
  top: -10px;
  left: 10px;
}

.heading {
  font-weight: 600;
  font-size: var(--font-size-1);
}

.text {
  font-weight: 400;
  font-size: var(--font-size-1);
  white-space: break-spaces;
}
</style>
